<template lang="pug">
v-container(fluid)
  template(v-if="contacts.length > 0")
    v-row(no-gutters align="center" class="tw-pt-2 tw-pb-0")
      v-col(cols="auto")
        span(class="tw-font-semibold tw-text-gray-700 tw-capitalize") {{ $t('Common.contacts') }}
      v-col(class="px-2")
        v-divider(class="tw-border-solid tw-border-t")
    v-row(no-gutters justify="space-around ")
      v-col(cols="12" class=" ")
        div(class="tw-flex tw-w-full tw-flex-wrap pt-2")
          kubiqa-contacts-contact-card(v-for="contact in contacts" :key="contact.id" :contact="contact")
</template>
<script>
export default {
  props: {
    contacts: {
      type: Array,
      default: () => [],
    },
  },
};
</script>
